import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberComma'
})
export class NumberCommaPipe implements PipeTransform {
    transform(value: number, args?: any): any {
        return formatNumber(Number(value), 'en-US', '1.0-0');
    }
}
